// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071137/js/" + chunkId + "." + {"44":"e65d2857","225":"b167783e","481":"a6d3030c","486":"b53bb6d5","770":"d65f5300"}[chunkId] + ".0.5206828570534469.chunk.js";
};